<script setup>
import { computed, watch } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { applyRouteTheme, applySessionBrand, setBrand } from '@/lib/uiTheme'

const route = useRoute()
const isPublicPage = computed(() => route.meta.public === true && route.meta.ui !== 'v2')
const isV2 = computed(() => route.matched.some((r) => r.meta?.ui === 'v2'))

watch(
  () => route.fullPath,
  () => {
    applyRouteTheme(route)
    // POS sets its own brand from the restaurant colour (PosLayout).
    if (route.path.startsWith('/restora')) setBrand('restora')
    else if (!route.path.startsWith('/pos')) applySessionBrand()
  },
  { immediate: true }
)
</script>

<template>
  <div
    class="min-h-screen w-full"
    :class="
      isV2 ? 'ui-root' : isPublicPage ? 'bg-surface-900 text-surface-100' : 'ui-root ui-legacy bg-surface-900 text-surface-100'
    "
  >
    <RouterView />
  </div>
</template>
